import Vida from './vida';

export default Vida;